var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_53007_10391)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.08802 3.08312L22.588 11.3331C22.7109 11.3961 22.814 11.4917 22.886 11.6094C22.958 11.7272 22.9961 11.8626 22.9961 12.0006C22.9961 12.1386 22.958 12.274 22.886 12.3918C22.814 12.5096 22.7109 12.6052 22.588 12.6681L6.08802 20.9181C5.98353 20.9717 5.86793 20.9999 5.75052 21.0006C5.63325 21.0047 5.51666 20.9811 5.41012 20.9319C5.30359 20.8827 5.21009 20.8092 5.13714 20.7173C5.06419 20.6254 5.01383 20.5176 4.9901 20.4027C4.96637 20.2878 4.96994 20.1689 5.00052 20.0556L7.04889 12.7225C7.11318 12.7404 7.18096 12.75 7.25098 12.75H13.251C13.6652 12.75 14.001 12.4142 14.001 12C14.001 11.5858 13.6652 11.25 13.251 11.25H7.25098C7.18194 11.25 7.11508 11.2593 7.05159 11.2768L5.03052 3.92312C4.99793 3.78745 5.00383 3.64539 5.04756 3.5129C5.09128 3.3804 5.17109 3.26273 5.27802 3.17312C5.38999 3.08163 5.52602 3.02446 5.66973 3.00849C5.81344 2.99253 5.9587 3.01844 6.08802 3.08312Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53007_10391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSend);
export default __webpack_public_path__ + "static/media/icon-send.634fb780653304012a1028330ae20a66.svg";
export { ForwardRef as ReactComponent };